import { PerfectiveVerb } from '../../types'

const заебать: PerfectiveVerb = {
  type: 'perfective verb',
  infinitive: 'заебать',
  imperativePluralSecondPerson: 'заебите',
  imperativeSingularSecondPerson: 'заеби',
  indicativeFuturePluralFirstPerson: 'заебём',
  indicativeFuturePluralSecondPerson: 'заебёте',
  indicativeFuturePluralThirdPerson: 'заебут',
  indicativeFutureSingularFirstPerson: 'заебу',
  indicativeFutureSingularSecondPerson: 'заебёшь',
  indicativeFutureSingularThirdPerson: 'заебёт',
  indicativePastPlural: 'заебали',
  indicativePastSingularFeminine: 'заебала',
  indicativePastSingularMasculine: 'заебал',
  indicativePastSingularNeuter: 'заебало',
}

export default заебать
